
export const META_PIXEL_ID = "1594476432044211";

declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void;
    _fbq?: unknown;
  }
}

const SCRIPT_ID = "meta-pixel-base-code";
const NOSCRIPT_ID = "meta-pixel-noscript";

/** The official Meta Pixel base code, injected verbatim as an inline script. */
const BASE_CODE = `
!function(f,b,e,v,n,t,s)
{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];
s?s.parentNode.insertBefore(t,s):(b.head||b.body).appendChild(t)}(window, document,'script',
'https://connect.facebook.net/en_US/fbevents.js');
fbq('init', '${META_PIXEL_ID}');
fbq('track', 'PageView');
`;

/**
 * Installs the Meta Pixel exactly the way the official snippet does: an inline
 * <script> in the document head plus the <noscript> image fallback.
 * Safe to call multiple times — it only ever installs once.
 */
export function initMetaPixel(): void {
  if (typeof document === "undefined") return;
  if (document.getElementById(SCRIPT_ID)) return;

  const head = document.head || document.documentElement;

  const script = document.createElement("script");
  script.id = SCRIPT_ID;
  script.type = "text/javascript";
  script.text = BASE_CODE;
  head.appendChild(script);

  const noscript = document.createElement("noscript");
  noscript.id = NOSCRIPT_ID;
  noscript.innerHTML =
    `<img height="1" width="1" style="display:none" alt="" ` +
    `src="https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1" />`;
  head.appendChild(noscript);
}

interface CheckoutEvent {
  contentName: string;
  value: number;
}

/** Fires InitiateCheckout when a visitor clicks through to a checkout page. */
export function trackInitiateCheckout({ contentName, value }: CheckoutEvent): void {
  if (typeof window === "undefined" || typeof window.fbq !== "function") return;
  window.fbq("track", "InitiateCheckout", {
    content_name: contentName,
    content_category: "Megapack 72HS",
    currency: "ARS",
    value,
  });
}
